export const ChangePasswordModalTranslations = {
  en: {
    changePasswordModal: {
      title: "Change password",
      subtitle: "Set a new password",
      passwordLabel: "Password",
      confirmPasswordLabel: "Confirm password",
      passwordInvalid: "Please provide a valid password (min 6 characters).",
      passwordsDoNotMatch: "Passwords do not match.",
      confirmPasswordInvalid: "Please confirm your password.",
      cancel: "Cancel",
      confirm: "Change password",
    },
  },
  es: {
    changePasswordModal: {
      title: "Cambiar contraseña",
      subtitle: "Establecer una nueva contraseña",
      passwordLabel: "Contraseña",
      confirmPasswordLabel: "Confirmar contraseña",
      passwordInvalid: "Por favor proporciona una contraseña válida (mínimo 6 caracteres).",
      passwordsDoNotMatch: "Las contraseñas no coinciden.",
      confirmPasswordInvalid: "Por favor confirma tu contraseña.",
      cancel: "Cancelar",
      confirm: "Cambiar contraseña",
    },
  },
};
